import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { BUTTON_HOVER } from "styles/colors";

function Actions() {
  const navigate = useNavigate();
  return (
    <Box sx={containerStyles}>
      {/* Button for add new user */}
      <Button
        startIcon={<AddIcon />}
        size="large"
        variant="contained"
        className="AddButtons"
        onClick={() => navigate("create")}
      >
        Add New
      </Button>
    </Box>
  );
}

export default memo(Actions);

const containerStyles = {
  my: 1,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  "& .MuiOutlinedInput-root": {
    "&:hover": {
      backgroundColor: BUTTON_HOVER,
    },
  },
  "& .MuiSelect-select": { height: "29px !important" },
  "& .Filter-toggle-btn": {
    height: 44,
    textTransform: "none",
    fontSize: "1rem",
  },
};
